// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"24ab84c1","453":"70dd3f1e","455":"0a771972","977":"abe8f63b"}[chunkId] + ".chunk.js";
};